<template>
  <div class="teams">
    <div class="info-row">
      <b>团队名称：</b>
      <el-select
        v-model="teamId"
        size="medium"
        placeholder="请选择团队"
        @change="getResult"
      >
        <el-option
          v-for="item in list"
          :key="item.teamId"
          :label="item.name"
          :value="item.teamId"
        >
        </el-option>
      </el-select>
      <div class="captain">
        队长姓名：
        <span v-if="teamInfo">{{ teamInfo.captainName }}</span>
      </div>
    </div>

    <el-table :data="resultInfo.postList" stripe class="list">
      <el-table-column
        prop="postName"
        label="岗位名称"
        width="120"
        align="center"
      >
      </el-table-column>
      <el-table-column prop="nickName" label="姓名" width="120" align="center">
      </el-table-column>
      <el-table-column prop="score" label="岗位得分" width="120" align="center">
      </el-table-column>
      <el-table-column prop="questionList" label="岗位能力要求">
        <template slot-scope="scope">
          <div v-for="(item, idx) in scope.row.questionList" :key="idx">
            <span>{{ item.question }}</span>
            <el-tag
              v-show="item.answer"
              :type="answerFormatter(item.answer, true)"
              size="mini"
              style="margin-left: 10px"
              >{{ answerFormatter(item.answer) }}</el-tag
            >
          </div>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
import { teamList } from "@/api/team";
import { result } from "@/api/projectPractice/questionnaire";
export default {
  data() {
    return {
      teamId: null,
      list: [],
      resultInfo: {},
    };
  },
  created() {
    this.getList();
  },
  computed: {
    teamInfo() {
      return this.teamId
        ? this.list.find((item) => item.teamId == this.teamId)
        : this.list[0];
    },
  },
  methods: {
    // 团队列表
    getList() {
      teamList({ classId: this.$route.query.id }).then((res) => {
        if (res.code == 0) {
          this.list = res.data;
          if (this.list) this.teamId = this.list[0].teamId;

          this.getResult();
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    // 评测结果信息
    getResult() {
      this.$loading.show();
      result({ teamId: this.teamId }).then((res) => {
        this.$loading.hide();
        if (res.code == 0) {
          this.resultInfo = res.data;
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    answerFormatter(tag, istag) {
      if (tag == "A") return istag ? "success" : "优秀";
      else if (tag == "B") return istag ? "" : "良";
      else if (tag == "C") return istag ? "warning" : "一般";
      else if (tag == "D") return istag ? "danger" : "差";
    },
  },
};
</script>

<style lang="less" scoped>
.teams {
  text-align: left;
  .info-row {
    margin-bottom: 10px;
    line-height: 36px;
    overflow: hidden;
    .captain {
      float: right;
      font-weight: bold;
      span {
        color: teal;
      }
    }
  }
  ::v-deep .list {
    .is-leaf {
      color: #333;
      background-color: #f5f5f5;
    }
  }
}
</style>